module.exports = __webpack_public_path__ + "media/images/sales/early/bg-apply-932c25efa415665c747355b5566b13e1.svg";